import React from "react";
import { Link } from "react-scroll";
import { FaArrowDown, FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { personalInfo, socialLinks } from "../../data/portfolioData";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero__particles">
        {[...Array(20)].map((_, i) => (
          <span key={i} className="hero__particle" />
        ))}
      </div>

      <div className="hero__container">
        <div className="hero__content">
          <p className="hero__greeting animate-fade-up">Hello, I'm</p>
          <h1 className="hero__name animate-fade-up delay-1">
            {personalInfo.name}
          </h1>
          <h2 className="hero__tagline animate-fade-up delay-2">
            {personalInfo.tagline}
          </h2>
          <p className="hero__location animate-fade-up delay-3">
            📍 {personalInfo.location}
          </p>

          <div className="hero__cta animate-fade-up delay-3">
            <Link
              to="projects"
              smooth={true}
              offset={-70}
              duration={500}
              className="btn btn--primary"
            >
              View My Work
            </Link>
            <Link
              to="contact"
              smooth={true}
              offset={-70}
              duration={500}
              className="btn btn--outline"
            >
              Get In Touch
            </Link>
          </div>

          <div className="hero__socials animate-fade-up delay-4">
            <a href={socialLinks.github} target="_blank" rel="noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <Link to="contact" smooth={true} offset={-70} duration={500} className="hero__social-link" aria-label="Email" style={{ cursor: "pointer" }}>
              <FaEnvelope />
            </Link>
          </div>
        </div>

        <div className="hero__image-wrapper animate-fade-up delay-2">
          <div className="hero__image-border">
            <img
              src={personalInfo.profileImage}
              alt={personalInfo.name}
              className="hero__image"
            />
          </div>
        </div>
      </div>

      <Link
        to="about"
        smooth={true}
        offset={-70}
        duration={500}
        className="hero__scroll-down"
      >
        <FaArrowDown />
      </Link>
    </section>
  );
};

export default Hero;
